import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { winslowConfig } from "./data";

export default function WinslowPage() {
  return <CityPageTemplate config={winslowConfig} />;
}